"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ImageCropper/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactcropper = require('react-cropper'); var _reactcropper2 = _interopRequireDefault(_reactcropper);

require('cropperjs/dist/cropper.css');

var _Modal = require('web/components/Modal');
var _imageAspect = require('./imageAspect');

/* The crop step shared by the profile photo and the branding uploads: the
 * picked image with a crop box, and the modal's Save and Cancel. A fixed
 * aspectRatio keeps the box at that shape; imageAspectRange locks it to the
 * picked image's own shape, held between two ratios (width / height), once
 * the image has loaded. onConfirm gets the cropper to export from. */























const ImageCropper = ({
  file, onConfirm, onCancel, isSubmitting, isCancelEnabled = true, primaryLabel = 'Save', aspectRatio, imageAspectRange, zoomable = false,
  autoCropArea, minCropBoxWidth = 50, minCropBoxHeight = 50, preview, className, children,
}) => {
  const fileURL = _react.useMemo.call(void 0, () => URL.createObjectURL(file), [file])
  _react.useEffect.call(void 0, () => () => URL.revokeObjectURL(fileURL), [fileURL])
  const cropperRef = _react.useRef(null)

  // The box takes the image's shape; with autoCropArea 1 cropperjs redraws
  // it as large as fits, centred.
  const onReady = _react.useCallback.call(void 0, () => {
    const cropper = _optionalChain([cropperRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.cropper])
    if (!cropper || !imageAspectRange) return
    const { naturalWidth, naturalHeight } = cropper.getCanvasData()
    cropper.setAspectRatio(_imageAspect.aspectWithin.call(void 0, naturalWidth, naturalHeight, imageAspectRange))
  }, [imageAspectRange])

  // Only the options given, so cropperjs keeps its defaults for the rest.
  const options = _react.useMemo.call(void 0, () => ({
    ...(preview !== undefined && { preview }),
    ...(aspectRatio !== undefined && { aspectRatio }),
    ...(autoCropArea !== undefined && { autoCropArea }),
    // The image can't be dragged out from under the box once it zooms.
    ...(zoomable && { viewMode: 1  }),
    ...(imageAspectRange && { ready: onReady }),
  }), [preview, aspectRatio, autoCropArea, zoomable, imageAspectRange, onReady])

  const confirm = _react.useCallback.call(void 0, () => {
    const cropper = _optionalChain([cropperRef, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.cropper])
    if (cropper) onConfirm(cropper)
  }, [onConfirm])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_reactcropper2.default, {
        src: fileURL,
        ref: cropperRef,
        guides: false,
        center: false,
        zoomable: zoomable,
        dragMode: zoomable ? 'move' : 'none',
        minCropBoxWidth: minCropBoxWidth,
        minCropBoxHeight: minCropBoxHeight,
        className: className,
        ...options, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
      )
      ,  children 
      , _react2.default.createElement(_Modal.ModalControls, {
        isPrimaryLoading: isSubmitting,
        primaryBtnLabel: primaryLabel,
        onPrimaryBtnClick: confirm,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onCancel,
        isSecondaryEnabled: isCancelEnabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      )
    )
  )
}

exports. default = ImageCropper
